import { LoadingSpinner } from "@app/shared";
import { FC, useState, useEffect, JSX } from "react";
import TemplateService from "@app/admin/manage-templates/templateService";
import { TemplateHistoryModel } from "./template";
import { Timeline, TimelineEvent } from "react-event-timeline";
import moment from "moment";

interface TemplateHistoryFlyoutProps {
  correlationId: string;
  templateCollectionId: number;
}

const TemplateHistoryFlyout: FC<TemplateHistoryFlyoutProps> = ({ correlationId, templateCollectionId }: TemplateHistoryFlyoutProps): JSX.Element => {
  const [loading, setLoading] = useState<boolean>(true);
  const [templateHistory, setTemplateHistory] = useState<TemplateHistoryModel>();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const templateService = new TemplateService();
      const data = await templateService.getTemplateHistory(templateCollectionId, correlationId);
      setTemplateHistory(data);
      setLoading(false);
    }

    fetchData();
  }, []);

  const formatDate = ((dateString: string) => {
    const dateFormat: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      hour: 'numeric',
      hour12: true,
      minute: 'numeric',
      month: 'long',
      year: 'numeric'
    }
    const offset = new Date().getTimezoneOffset();
    const dateToFormat = new Date(dateString);
    dateToFormat.setMinutes(dateToFormat.getMinutes() - offset);
    return Intl.DateTimeFormat("en-US", dateFormat).format(dateToFormat);
  });

  return (
    loading ? <LoadingSpinner /> :
    !templateHistory ? null :
    <>
      <Timeline>
        {templateHistory.events
          .sort((a, b) => moment(b.displayDate).unix() - moment(a.displayDate).unix())
          .map((templateEvent) => {
          return (
            <TimelineEvent
              key={templateEvent.displayDate.valueOf()}
              titleStyle={{ fontWeight: 'bold'}}
              title={`${templateEvent.eventDescription} by ${templateEvent.user} on`}
              subtitle={formatDate(templateEvent.displayDate)}
              icon={<i className={`fa fa-check-circle history-icon-success fs22`} />}
              bubbleStyle={{ background: "#fff", border: "none", }}
            >
              {!templateEvent.comment ? null :
                <>
                  <div style={{ fontWeight: 'bold'}}>Comments:</div>
                  <div style={{ whiteSpace: 'pre' }}>{templateEvent.comment}</div>
                </>
              }
            </TimelineEvent>
        )})}
      </Timeline>
    </>
  );
};

export default TemplateHistoryFlyout;